export const WHEN_TO_USE = `Apply label formatting - set what field values appear as labels on
components and references currently visible in the view (e.g. "add lifecycle to component labels",
"show the reference type on connections", "display cost on the diagram").

Label formatting is a visual diagram/view action: it changes what appears as labels on components
and references, but does not fetch, compute, summarize, or report information in chat.

If user clearly refers to label formatting, labels in the visualization, or displaying the field values in the visualization - apply label formatting.
If the question is about data ("what is the total cost of the applications") - show the information in chat.
If the request is ambiguous ("show total cost of the applications") - offer two options: A. Show the information in chat. B. Add the information as labels on the diagram/view.
Briefly describe both options and ask the user which one they want.

This command changes labels only - not colours, icons, or grouping.`;

export const LABEL_CONTEXT_DESCRIPTION = `Every component already shows its name. This tool does not control that label.

References may also show their reference type name as part of the built-in reference label display.
That visibility is controlled by 'currentReferenceMainLabelRule' (see below), not by 'rules'.

'rules' only ADD extra field-value labels on top of these; they never replace them.
This tool has NO way to hide or change the component name label — it is not exposed here at all.
Never try to hide it via a field rule, and do not touch it when the user asks to "remove all
labels" or "hide all labels": that request only means clearing 'rules' — the component name will still show regardless.

The context provides:
'availableLabelFields' - all valid field names for label formatting, split by
'component' and 'reference'. Each field has a 'name' (the identifier to use in 'rules.fields')
and a 'label' (the human-readable name). Use ONLY these names in 'rules.fields' —
do not invent names.
Each side has 'builtInFields', which every type has, 'customFields', and 'fieldNamesByType', the
names of the custom fields each type has. A rule with 'typeName' can use only the built-in fields
and the field names listed for that type. An empty 'fieldNamesByType' on the reference side means the
view has no references, so do not add reference rules.

'summary' - distributions of field values currently visible in the view. Use it to understand
what data is available and choose relevant fields — but use 'availableLabelFields' for the
authoritative list of valid field names.

'currentFieldRules' — the label rules applied now, in the same shape as 'rules' entries (type 'component' or 'reference').
   A rule without 'typeName' applies to ALL types; one with 'typeName' is scoped to that type.
   Prefer one all-types rule when the user wants the same label on all entities of a kind; only
   use 'typeName' when the user explicitly wants different labels per type.

   IMPORTANT — hiding field names on all-types rules is NOT supported:
   When typeName is absent, 'showFieldName' is always true (the UI enforces this).
   If the user asks to hide field names on ALL component or reference types:
   - DO NOT call this tool
   - Explain that field names cannot be hidden on all-types rules — it is a UI constraint
   - Suggest creating type-specific rules (with typeName set) if they want showFieldName: false

'currentReferenceMainLabelRule' — controls whether the reference TYPE NAME appears on reference
labels. Always preserve this value unless the user explicitly asks to show or hide reference
type names. "show reference type" means only changing this rule, never adding a field rule.

'viewLabelConstraints' - when present, describes a limitation of the current view that affects
how labels are displayed (e.g. reference labels not shown, only first field shown).

Respect these constraints strictly:
If the current view does not support reference labels, DO NOT create reference field rules.
If the current view does not support reference labels, DO NOT change the value of 'currentReferenceMainLabelRule' either.
If the user asks for a reference label change that the current view cannot display, explain the limitation and do not apply that change.`;
